module.exports = __webpack_public_path__ + "img/strikethrough.4ecec91c.svg";